import { render, staticRenderFns } from "./Adresses.vue?vue&type=template&id=5b14ab4c&"
import script from "./Adresses.vue?vue&type=script&lang=js&"
export * from "./Adresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Adresses.vue"
export default component.exports